const text = (key, label, width = 180) => ({ key, label, width });
const number = (key, label, aggregate = 'sum', width = 120) => ({ key, label, numeric: true, aggregate, width });
const action = (key, label) => ({ key, label, width: 150 });
const transactionDetailColumns = partyLabel => [text('Party', partyLabel, 260), number('Quantity', 'Qty'),
  number('UnitRate', 'Unit'), number('WithVATAmount', 'Amount'), text('Stockdesc', 'Stock Description', 280)];

export const itemColumns = [
  text('SubCategory', 'Sub Category', 230), number('Quantity', 'Quantity in Kg'),
  number('AvgRateForKg', 'Rate for Kg'), number('GrossAmount', 'Gross Amount'),
  number('Purdet_Quantity', 'Quantity'), number('UnitRate', 'Unit Rate'),
  number('VatAmount', 'VAT Amount'), number('WithVATAmount', 'Net Amount'), action('Details', 'Details'),
];
export const reportDefinitions = {
  'sales-customers': {
    title: 'Sales by Customer', section: 'Sales', endpoint: '/api/salesbyitems',
    columns: [text('SAL_SUBLEDGER_DOCNO', 'A/C Code', 130), text('Customer', 'Account Description', 260),
      number('CountOfSales', 'Count of Sales'), number('GrossAmount', 'Gross Amount'),
      number('DiscountAmount', 'Discount Amount'), number('VatAmount', 'VAT Amount'),
      number('NetAmount', 'Net Amount'), number('Credit', 'Credit'),
      action('ItemSummary', 'Item Summary'), text('salemn', 'Sales Person')],
  },
  'sales-items': { title: 'Sales by Items', section: 'Sales', endpoint: '/api/transaction-summary', columns: itemColumns },
  'purchase-items': { title: 'Purchases by Items', section: 'Purchases', endpoint: '/api/transaction-summary-pur', columns: itemColumns },
  'purchase-suppliers': {
    title: 'Purchases by Supplier', section: 'Purchases', endpoint: '/api/purchase-summary',
    params: { customer: 'true' }, initialSort: { key: 'GrossAmount', direction: 'desc' },
    columns: [text('PUR_AC_DOCNO', 'A/C Code', 130), text('Customer', 'Account Description', 270),
      number('GrossAmount', 'Gross Amount'), number('DiscountAmount', 'Discount Amount'),
      number('VatAmount', 'VAT Amount'), number('NetAmount', 'Net Amount'), action('ItemSummary', 'Item Summary')],
  },
  'sales-customer-items': {
    title: 'Item Summary', groupBy: ['STK_GRP1_DESC'],
    columns: [text('Customer', 'A/C Description', 180), text('StockDesc', 'Stock Description', 235),
      text('STK_GRP1_DESC', 'Group', 120), number('Qty', 'Qty', 'sum', 90), number('NET_WEIGHT', 'KG Qty', 'sum', 100),
      number('Rate', 'Rate', 'mean', 90), number('GrossAmount', 'Gross Amount'),
      number('VatAmount', 'VAT Amount', 'sum', 100), number('NetAmount', 'Net Amount'), action('Invoices', 'Invoice Details')],
  },
  'sales-invoices': {
    title: 'Invoice Details', columns: [text('DocType', 'Doc Type', 100), text('DocNo', 'Invoice No.', 140),
      text('Documentdate', 'Document Date', 150), text('SALDET_STOCK_DESC', 'Stock Description', 270), text('UNIT', 'Unit', 90),
      number('SALDET_QTY', 'Qty'), number('KG_QTY', 'KG Qty'), number('SALDET_RATE', 'Rate'),
      number('SALDET_GROSS_AMOUNT', 'Gross Amount'), number('SALDET_VAT_AMOUNT', 'VAT Amount'), text('AD', 'AD', 100)],
  },
  'sales-item-details': {
    title: 'Transaction Details', initialSort: { key: 'WithVATAmount', direction: 'desc' },
    columns: transactionDetailColumns('Customer Name'),
  },
  'purchase-item-details': {
    title: 'Transaction Details', initialSort: { key: 'WithVATAmount', direction: 'desc' },
    columns: transactionDetailColumns('Supplier Name'),
  },
  'purchase-supplier-items': {
    title: 'Item Summary', initialSort: { key: 'GrossAmount', direction: 'desc' },
    columns: [text('StockDesc', 'Stock Description', 270), number('Qty', 'Qty'), number('Gorss_weight', 'KG Qty'),
      number('Rate', 'Rate for Kg'), number('GrossAmount', 'Gross Amount'),
      text('Customer', 'A/C Description', 250), text('Invoices', 'Invoice Details', 140)],
  },
};

export function normalizeReportRows(key, rows) {
  return rows.map(row => {
    if (key === 'purchase-suppliers') return { ...row, PUR_SUBLEDGER_DOCNO: row.PUR_SUBLEDGER_DOCNO || row.DOCNO };
    if (key === 'sales-customer-items') return { ...row,
      StockDesc: row.StockDesc || row.stockdesc,
      NET_WEIGHT: row.NET_WEIGHT ?? row.Gorss_weight,
      Rate: row.Rate ?? row.RATE ?? row.RateForKG ?? row.RATE_PER_KG ?? 0,
      Invoices: row.Invoices || 'View Invoice' };
    if (key === 'purchase-supplier-items') return { ...row,
      StockDesc: row.StockDesc || row.stockdesc,
      Rate: row.RATE ?? row.Rate ?? row.RATE_PER_KG ?? row.RateForKG ?? 0 };
    if (key === 'sales-item-details' || key === 'purchase-item-details') return { ...row,
      Party: row.Party || row.PartyName, Stockdesc: row.Stockdesc || row.StockDesc };
    if (key === 'sales-invoices') return { ...row,
      SALDET_STOCK_DESC: row.SALDET_STOCK_DESC ?? row.StockDesc,
      SALDET_QTY: row.SALDET_QTY ?? row.Qty, KG_QTY: row.KG_QTY ?? row.NET_WEIGHT,
      SALDET_RATE: row.SALDET_RATE ?? row.Rate,
      SALDET_GROSS_AMOUNT: row.SALDET_GROSS_AMOUNT ?? row.GrossAmount,
      SALDET_VAT_AMOUNT: row.SALDET_VAT_AMOUNT ?? row.VatAmount };
    return { ...row };
  });
}

// Keep the existing procedure parameters, including their original case.
export function detailRequest(reportKey, row, dates, account = {}) {
  if (reportKey === 'sales-customers') return { key: 'sales-customer-items', endpoint: '/api/item-summary',
    params: { sal_subledger_docno: row.SAL_SUBLEDGER_DOCNO, ...dates }, account: row, subtitle: row.Customer };
  if (reportKey === 'sales-customer-items') return { key: 'sales-invoices', endpoint: '/api/invoice-details',
    params: { sal_subledger_docno: row.SAL_SUBLEDGER_DOCNO || account.SAL_SUBLEDGER_DOCNO,
      sal_ac_docno: row.SAL_AC_DOCNO || account.SAL_AC_DOCNO, saldet_stock_docno: row.SALDET_STOCK_DOCNO, ...dates },
    account, subtitle: row.StockDesc };
  if (reportKey === 'sales-items' || reportKey === 'purchase-items') return {
    key: reportKey === 'purchase-items' ? 'purchase-item-details' : 'sales-item-details',
    endpoint: reportKey === 'purchase-items' ? '/api/transaction-details-pur' : '/api/transaction-details',
    params: { SubCategory: row.SubCategory, ...dates }, subtitle: row.SubCategory };
  if (reportKey === 'purchase-suppliers') return { key: 'purchase-supplier-items', endpoint: '/api/item-summary1', method: 'POST',
    params: { PUR_SUBLEDGER_DOCNO: row.PUR_SUBLEDGER_DOCNO, PUR_AC_DOCNO: row.PUR_AC_DOCNO, Customer: row.Customer, DM_DOCNO: row.DM_DOCNO, ...dates },
    account: row, subtitle: row.Customer };
  return null;
}
